import { render, staticRenderFns } from "./Turnover.vue?vue&type=template&id=7aabad3a&"
import script from "./Turnover.vue?vue&type=script&lang=js&"
export * from "./Turnover.vue?vue&type=script&lang=js&"
import style0 from "./Turnover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports